import React, {useEffect} from 'react';
import Switch from 'react-switch';
import { useSelector, useDispatch } from 'react-redux';
import { translation } from 'helpers/utilsHelper.js';
import S from './StyledBetSlipBonus.js';
import { TOGGLE_AKO_BONUS, TOGGLE_STF_BONUS, calculatePossibleWin } from 'betSlipActions.js';

const BetSlipBonus = ({ totalBonus, tax }) => {
    const bonus = totalBonus?.currentBonusValue || 0;
    const dispatch = useDispatch();

    const user = useSelector(state => state.Auth.user);

    const toggleAKOBonus = useSelector(state => state.BetSlip.toggleAKOBonus);
    const toggleSTFBonus = useSelector(state => state.BetSlip.toggleSTFBonus);

    const handleToggleAKO = () => {
        dispatch({ type: TOGGLE_AKO_BONUS, payload: { value: !toggleAKOBonus } });
    };

    const handleToggleSTF = () => {
        dispatch({ type: TOGGLE_STF_BONUS, payload: { value: !toggleSTFBonus } });
    };

    useEffect(() => {
        if (parseFloat(bonus) === 0 && toggleAKOBonus) {
            dispatch({ type: TOGGLE_AKO_BONUS, payload: { value: false } });
        }

        if (parseFloat(tax)=== app.config.defaultTaxFactor && toggleSTFBonus) {
            dispatch({ type: TOGGLE_STF_BONUS, payload: { value: false } });
        }
    }, [bonus, tax, dispatch]);

    useEffect(() => {
        dispatch(calculatePossibleWin(tax));
    }, [toggleAKOBonus, toggleSTFBonus, tax, dispatch]);

    return (
        <>
            {(parseFloat(bonus) > 0 && user?.customerApprovalCombinationBonusEnable) || (parseFloat(tax) !== app.config.defaultTaxFactor && user.customerApprovalSTFBonusEnable) ? (
                <S.BetSlipBonusWrapper>
                    {parseFloat(bonus) > 0 && user?.customerApprovalCombinationBonusEnable ? 
                        (
                            <S.BetSlipBonusOptionLabel>
                                <S.BetslipBonusLabel>{translation('betSlip_enableAKO')}</S.BetslipBonusLabel>
                                <Switch 
                                    height={20}
                                    width={40}
                                    onChange={handleToggleAKO}
                                    checked={toggleAKOBonus}
                                />
                            </S.BetSlipBonusOptionLabel>
                        )
                    : null}

                    {parseFloat(tax) !== app.config.defaultTaxFactor && user?.customerApprovalSTFBonusEnable ?
                        <S.BetSlipBonusOptionLabel>
                            <S.BetslipBonusLabel>{translation('betSlip_enableSTF')}</S.BetslipBonusLabel>
                            <Switch 
                                height={20}
                                width={40}
                                onChange={handleToggleSTF}
                                checked={toggleSTFBonus}
                            />
                        </S.BetSlipBonusOptionLabel>
                    : null}
                </S.BetSlipBonusWrapper>
            ) : null}
        </>
    );
};

export default BetSlipBonus;